<!-- 
<div class="container">
    <h3 class="mt-4">Aktivoi</h3>

    <ng-container *ngIf="showErr">
        <div class="alert alert-danger">
            <p class="body2b-b">Aktivointi epäonnistui. Koodia ei ole tai se on vahnentunut.</p>
        </div>
    </ng-container>

    <div id="error" class="d-none">
        <div class="alert alert-danger">
            <p class="body2b-b">Aktivointi epäonnistui. Koodia ei ole tai se on vahnentunut.</p>
        </div>
    </div>

    <ng-container *ngIf="isLoading">
        <div id="loader" class="loader-container mt-4 mb-4">
            <div class="loader mx-auto"></div>
            <p class="body2b-b text-center mt-4 mb-4">Odota...</p>
        </div>
    </ng-container>

    <div id="my-cont" style="display: none;">
        <p class="mb-4">Viimeistele käyttäjätilisi painamalla "Aktivoi" -painiketta</p>
        <button #recaptcha class="btn btn-formed-main-green w-100 mt-4"   ><i class="fas fa-sign-in-alt me-2"></i>Aktivoi</button>

    </div>

    <div id="success" class="d-none">
        <div class="alert alert-success">
            <p class="body2b-b">Aktivointi onnistui. Voit palata sovellukseen alla olevasta painikkeesta.</p>
            <div class="d-flex justify-content-center">
                <p (click)="toApp()" class="btn btn-formed-main-green">
                    Sovellukseen
                </p>
            </div>
        </div>
    </div>


    

</div> -->



<div class="bg-login">
    <div class="container h-100">
    <div class="wrap text-center h-100 align-content-center">
        <div class="col-12 row m-0 p-0">
            <div class="col-3"></div>
            <div class="col-12 col-lg-6 bg-f-w justify-content-center z-100">
                <div class="col-12 m-0 row">
                    <div class="col-3"></div>
                    <div class="col-12 col-md-6 p-0 mt-4">
                        <div class="col-12 text-center p-0 mt-4">
                            <img src="../../assets/images/rekruu_logo.png" alt="" height="110" class="mx-auto">
                            <h4 class="semiboldtextblue90024 mt-4">Aktivoi käyttäjätilisi</h4>
                            <p class="normaltextblue90016 f-os mt-2">Aktivoi käyttäjätilisi painamalla alla olevaa painiketta</p>
                        </div>
                    </div>
                    <div class="col-3"></div>
        
                </div>
        
                <div class="col-12 p-0 row m-0">
                    <div class="col-1"></div>
                    <div class="col-12 col-md-10 p-0">
                        <div class="col-12 p-0 ">
                            <div class="col-12 login-form-bg pb-4">
                                <ng-container *ngIf="showErr">
                                <div class="alert alert-danger">
                                    <p class="body2b-b mb-0">Aktivointi epäonnistui. Koodia ei ole tai se on vahnentunut.</p>
                                </div>
                            </ng-container>
                        
                            <div id="error" class="d-none">
                                <div class="alert alert-danger">
                                    <p class="body2b-b mb-0">Aktivointi epäonnistui. Koodia ei ole tai se on vahnentunut.</p>
                                </div>
                            </div>
                        
                            <ng-container *ngIf="isLoading">
                                <div id="loader" class="loader-container mt-4 mb-4">
                                    <div class="loader mx-auto"></div>
                                    <p class="body2b-b text-center mt-4 mb-4">Odota...</p>
                                </div>
                            </ng-container>
                        
                            <div id="my-cont" style="display: none;">
                                <p class="mb-4">Viimeistele käyttäjätilisi painamalla "Aktivoi" -painiketta</p>
                                <button #recaptcha class="btn btn-formed-main-green w-100 mt-4"   ><i class="fas fa-sign-in-alt me-2"></i>Aktivoi</button>
                        
                            </div>
                        
                            <div id="success" class="d-none">
                                <div class="alert alert-success">
                                    <p class="body2b-b">Aktivointi onnistui. Voit palata sovellukseen alla olevasta painikkeesta.</p>
                                    <div class="d-flex justify-content-center">
                                        <p (click)="toApp()" class="btn btn-formed-main-green mb-0">
                                            Sovellukseen
                                        </p>
                                    </div>
                                </div>
                            </div>
                        
                    </div>
                        </div>
                    </div>
                    <div class="col-1"></div>
        
                </div>
        
            </div>
            <div class="col-3"></div>
        </div>

    </div>
    </div>

</div>

